import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  tools: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createNewTool: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateTool: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteTool: {
    data: {},
    isLoading: false,
    hasError: false,
  }  
};

export const toolReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_TOOLS:
      return {
        ...newState,
        tools: { ...newState.tools, isLoading: true, hasError: false },
      };
    case actionTypes.GET_TOOLS_SUCCESS:
      return {
        ...newState,
        tools: { ...newState.tools, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_TOOLS_FAILURE:
      return {
        ...newState,
        tools: { ...newState.tools, data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_TOOL:
      return {
        ...newState,
        createNewTool: { ...newState.createNewTool, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_TOOL_SUCCESS:
      return {
        ...newState,
        createNewTool: { ...newState.createNewTool, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_TOOL_FAILURE:
      return {
        ...newState,
        createNewTool: { ...newState.createNewTool, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_TOOL:
      return {
        ...newState,
        updateTool: { ...newState.updateTool, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_TOOL_SUCCESS:
      return {
        ...newState,
        updateTool: { ...newState.updateTool, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_TOOL_FAILURE:
      return {
        ...newState,
        updateTool: { ...newState.updateTool, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.DELETE_TOOL:
        return {
          ...newState,
          deleteTool: { ...newState.deleteTool, isLoading: true, hasError: false },
        };
      case actionTypes.DELETE_TOOL_SUCCESS:
        return {
          ...newState,
          deleteTool: { ...newState.deleteTool, data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_TOOL_FAILURE:
        return {
          ...newState,
          deleteTool: { ...newState.deleteTool, data: action.payload, isLoading: false, hasError: true },
        };

    default:
      return { ...newState };
  }
};
